import { LayoutMeasureAdapter, LayoutMeasureContext, MeasurementSource } from "./types";

function createLiveMeasurementSource(): MeasurementSource {
  return {
    resolveNode(node: Node): Node {
      return node;
    },
    cleanup(): void {},
  };
}

export class InlineFlowMeasureAdapter implements LayoutMeasureAdapter {
  readonly id = "inline-flow";

  supports(_element: HTMLElement, context: LayoutMeasureContext): boolean {
    return context.display !== "flex" && context.display !== "inline-flex";
  }

  createSource(_element: HTMLElement, _context: LayoutMeasureContext): MeasurementSource {
    return createLiveMeasurementSource();
  }
}
